import React from 'react';
/**
 * Replaces the names of multiple object keys with the values provided
 * @param {Object.<string, string>} keysMap
 * @param {Object.<string, string>} obj
 */

const renameKeys = (keysMap, obj) => Object.keys(obj).reduce((acc, key) => ({ ...acc,
  ...{
    [keysMap[key] || key]: obj[key]
  }
}), {});
/**
 * Creates React elements from JSON objects passed from Icons.js
 * @param {Array.<Object>} element
 * @return {Array.<Node>} node map
 */


const createElement = elements => elements.map((element, index) => {
  const {
    type,
    properties,
    children
  } = element;
  const realKids = children && children.length ? createElement(children) : children;
  properties.key = index;

  if (properties['stroke-width'] || properties['fill-rule']) {
    return React.createElement(type, renameKeys({
      'stroke-width': 'strokeWidth',
      'fill-rule': 'fillRule'
    }, properties), realKids);
  }

  return React.createElement(type, properties, realKids);
});

export default createElement;